import { render, staticRenderFns } from "./BadgeBox.vue?vue&type=template&id=4e329895&scoped=true&"
import script from "./BadgeBox.vue?vue&type=script&lang=js&"
export * from "./BadgeBox.vue?vue&type=script&lang=js&"
import style0 from "./BadgeBox.vue?vue&type=style&index=0&id=4e329895&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e329895",
  null
  
)

export default component.exports